import React, { FC, useContext } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { UserContext } from 'src/contexts/UserContext';

import { Header } from 'src/elements/Header';
import { Footer } from 'src/elements/Footer';
import GlobalNotifications from 'src/elements/GlobalNotifications';

const DefaultLayout: FC<{}> = () => {
  const location = useLocation();
  const { isLoggedIn, loading, error } = useContext(UserContext);

  if (!loading && !error && !isLoggedIn) {
    const loginLink = `/login?redirect=${location.pathname}`;
    return <Navigate to={loginLink} />;
  }

  return (
    <>
      <Header />
      <main role="main">
        <GlobalNotifications />
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default DefaultLayout;
